"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogBase = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Button_1 = require("../Button");
var utilities_1 = require("../typings/utilities");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var checkKeyHandler = function (event, keyCode, handler) {
    if (event.keyCode === keyCode && handler) {
        event.preventDefault();
        event.stopPropagation();
        handler();
    }
};
var shouldSubmitOnEnterPress = function (_a) {
    var target = _a.target;
    var _b = target, tagName = _b.tagName, type = _b.type;
    var tagNameInLowercase = tagName.toLowerCase();
    var typeInLowercase = type ? type.toLowerCase() : "";
    return (tagNameInLowercase === "textarea" ||
        (tagNameInLowercase === "input" && (typeInLowercase === "text" || typeInLowercase === "number")));
};
/**
 * @internal
 */
var DialogBase = /** @class */ (function (_super) {
    tslib_1.__extends(DialogBase, _super);
    function DialogBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onKeyDown = function (event) {
            var _a = _this.props, submitOnEnterKey = _a.submitOnEnterKey, onCancel = _a.onCancel, onSubmit = _a.onSubmit;
            // don't call onSubmit when pressing enter key on input fields
            var isEnterKeyDownOnInputField = event.keyCode === utilities_1.ENUM_KEY_CODE.KEY_CODE_ENTER && shouldSubmitOnEnterPress(event);
            if (submitOnEnterKey === false && isEnterKeyDownOnInputField) {
                return;
            }
            checkKeyHandler(event, utilities_1.ENUM_KEY_CODE.KEY_CODE_ENTER, onSubmit);
            checkKeyHandler(event, utilities_1.ENUM_KEY_CODE.KEY_CODE_ESCAPE, onCancel);
        };
        return _this;
    }
    DialogBase.prototype.getDialogClasses = function (additionalClassName) {
        return classnames_1.default("overlay", "gd-dialog", additionalClassName, this.props.className);
    };
    DialogBase.prototype.renderCloseButton = function () {
        return (react_1.default.createElement("div", { className: "gd-dialog-close" },
            react_1.default.createElement(Button_1.Button, { className: "gd-button-link gd-button-icon-only gd-icon-cross s-dialog-close-button", value: "", onClick: this.props.onClose || this.props.onCancel })));
    };
    DialogBase.prototype.render = function () {
        var dialogClasses = this.getDialogClasses();
        return (react_1.default.createElement("div", { tabIndex: 0, onKeyDown: this.onKeyDown },
            react_1.default.createElement("div", { className: dialogClasses },
                this.props.displayCloseButton && this.renderCloseButton(),
                this.props.children)));
    };
    DialogBase.defaultProps = {
        children: false,
        className: "",
        displayCloseButton: false,
        submitOnEnterKey: true,
        onCancel: noop_1.default,
        onSubmit: noop_1.default,
    };
    return DialogBase;
}(react_1.PureComponent));
exports.DialogBase = DialogBase;
//# sourceMappingURL=DialogBase.js.map